import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slack as SlackIcon } from "@air/next-icons";
import { memo } from "react";
import { displaySlackChannelName } from "../utils/displaySlackChannelName";
export const ConnectedSlackChannel = /*#__PURE__*/ memo((param)=>{
    let { channelName } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex h-12 flex-col justify-center border-0 bg-grey-3 p-3 text-grey-11",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ _jsx(SlackIcon, {
                        className: "mr-1 mt-0.5 size-4"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-14 font-normal text-inherit",
                        children: "Connected to Slack"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ml-5 text-12 font-normal text-grey-10",
                children: displaySlackChannelName(channelName)
            })
        ]
    });
});
ConnectedSlackChannel.displayName = "ConnectedSlackChannel";
